import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    rendered: false,
    token: '',
    size: 'large',
    currentUser: '',
    positionStation: localStorage.positionStation || '1',
    menuList: [],
    menuPathList: [],
    authorizesInfo: {}
  },

  mutations: {
    setToken(state, token) {
      if (token) {
        state.token = token
        localStorage.setItem('accessToken', token)
      }
    },
    setMenuList(state, menu) {
      if (menu.length > 0) {
        state.menuList = menu
      }
    },
    setMenuPathList(state, menuPathList) {
      if (menuPathList) {
        state.menuPathList = menuPathList
      }
    },
    upadate(state, positionStation) {
      if (positionStation) {
        state.positionStation = positionStation
        localStorage.positionStation = positionStation
      }
    },
    // passConfirm(state,iscancel) {
    //   debugger
    //   if(iscancel == "1"){
    //     state.passFlag = true
    //     console.log(state.passFlag)
    //   }
    // },
    routeLoaded(state) {
      state.rendered = true
    },

    setScreenSize(state, size) {
      state.size = size
    },
    setCurrentUser(state, currentUser) {
      state.currentUser = currentUser
    },
    SET_AUTHORIZES: (state, authorizesInfo) => {
      state.authorizesInfo = authorizesInfo
      localStorage.setItem('authorizesInfo', authorizesInfo)
    },
  },
})

export default store
